"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroBet = void 0;
/**
 * Presentation to trigger ZeroBet.
 *
 * For use in "idle" gameRound state, usually in FREE_SPIN mode or RESPIN or such.
 *
 * Created: 2019-08-16
 * @author jonas
 */
const gsap_1 = require("gsap");
const EventHandler_1 = require("../../../../core/event/EventHandler");
const GameEvent_1 = require("../../../../core/event/GameEvent");
const BalanceEvent_1 = require("../../../../core/balance/event/BalanceEvent");
class ZeroBet {
    constructor() {
        this.stagger = 0;
    }
    getAnimation(data) {
        const tl = new gsap_1.TimelineLite();
        tl.add(() => {
            EventHandler_1.EventHandler.dispatchEvent(new GameEvent_1.GameEvent(BalanceEvent_1.BalanceEvent.ZERO_BET));
        });
        return tl;
    }
}
exports.ZeroBet = ZeroBet;
//# sourceMappingURL=ZeroBet.js.map